<template>
    <v-container fluid ma-3 pa-3>
        <v-layout row wrap justify-center>
            <v-flex>
                <span class="style_title">Synonyms</span>
                <br>
                <br>
                <div>
                    <span class="style_description" style="white-space: pre-line">In the “Synonyms” page you can manage the list of synonyms.

</span>
                    <br>

                    <span class="style_paragraph" style="white-space: pre-line">The meaning and role of synonyms</span>
                    <br>
                    <span class="style_description" style="white-space: pre-line">Synonyms are important to improve the effectiveness of advanced search available in the chat and in “Startup Search” page.
Each entry consists of:
                        <ul>
                            <li>basic word</li>
                            <li>synonyms: list of synonyms associated with the basic word</li>
                        </ul>
When performing a search, therefore, these synonyms will be taken into consideration. A startup that contains a basic word will be returned either if the query contains the basic word itself, or if it contains one of the specified synonyms.

</span>
                    <br>

                    <span class="style_paragraph" style="white-space: pre-line">Example</span>
                    <br>
                    <span class="style_description" style="white-space: pre-line">If I have the synonym:
                        <ul>
                            <li>basic word: iot</li>
                            <li>synonyms: internet of things, internet delle cose</li>
                        </ul>
If the description of startup "AAA" contains the word "iot" and the query is "iot" the startup "AAA" is retrieved.
In addition, if the query is "internet of things" the startup "AAA" is retrieved, although the description does not contain these exact words

</span>
                    <br>

                    <span class="style_paragraph" style="white-space: pre-line">How to add a synonym</span>
                    <br>
                    <span class="style_description" style="white-space: pre-line">To add a new synonym click the blue “Add Synonym” button. Then, add the basic word and the list of synonyms <strong>separated by comma</strong>.
Click on green “Submit” button.
                         <br>
                        <v-img
                                max-width="600"
                                :src="require('@/assets/img/help/synonyms.png')"
                        >
                </v-img>

You can also modify an already existing synonym by clicking the pencil icon in the corresponding line.

</span>
                </div>
                <br>


            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>

    export default {
        name: "SynonymsHelp",
        components: {},
        data() {
            return {

            }
        },

        methods: {

        }
    }
</script>

<style scoped>
    .style_description{
        font-size: 18px;
    }

    .style_paragraph{
        font-size: 22px;
        font-weight: bold;
    }

    .style_title{
        font-size: 34px;
        font-weight: bold;
    }

</style>